import React from "react";
import { SlideShell } from "../../../shared/components/SlideShell";

export const Slide1 = ({ t, total, onActive }) => {
  return (
    <SlideShell theme="emissor"
      index={0}
      total={total}
      label="Cover"
      onActive={onActive}
      bgStyle={{
        "--slide-bg": "linear-gradient(118deg,rgba(3,3,2,.95),rgba(1,2,1,.72)), repeating-linear-gradient(125deg, rgba(213,183,45,.8) 0 2px, transparent 2px 15px), radial-gradient(900px 600px at 28% 80%,rgba(218,186,44,.34),transparent 60%)"
      }}
    >
      
      <div className="logo-mark">
        Emissor<span>.PRO</span>
      </div>

      <h1>
        <span>{t.title}</span>
        <span className="gold">{t.subtitle}</span>
      </h1>

      <p className="lead">{t.body}</p>

      <div className="pillrow">
        <span className="pill">NF-e · NFC-e · CT-e · MDF-e · NFS-e</span>
        <span className="pill">Tax engine + apuração</span>
        <span className="pill">SPED · ECD · ECF</span>
        <span className="pill">Accounting close</span>
      </div>

      <div className="side-stat">
        <div className="label">Partner Deck</div>
        <div className="val">2026</div>
      </div>
    </SlideShell>
  );
};


